module.exports = __webpack_public_path__ + "static/media/best_connect.75a61ae5.png";